import React from 'react';
import { Row } from 'antd';
import { ProductDashboardChartsViewProps } from 'enums/ProductDashboardChartsEnums';
import { HelpDeskInputFieldEnum } from 'context/HelpDeskTooltipContext/helpDeskInputFieldEnum';
import { ReactComponent as Semi } from 'assets/icons/semi-circle-dqr.svg';
import { ReactComponent as Needle } from 'assets/icons/needle.svg';
import HelpdeskInfoComponent from 'shared/components/HelpdeskInfo';
import styles from '../ProductDashboardCharts.module.scss';
import { DqrData } from 'services/DashboardService/dashboard.service';

interface DqrMetricComponentProps {
  dqrData?: DqrData;
  degree: number;
  translateX: number;
  translateY: number;
}

const DqrMetricComponent: React.FC<DqrMetricComponentProps> = ({
  dqrData,
  degree,
  translateX,
  translateY,
}) => {
  if (!dqrData?.dqrMetrics) return null;

  return (
    <div className={styles.dqr}>
      <h3>
        {ProductDashboardChartsViewProps.Data_Quality_Rating}
        <HelpdeskInfoComponent
          fieldKey={HelpDeskInputFieldEnum.DQR}
          className={styles.infoIcon}
        />
      </h3>
      <Row>
        <div className={styles.dqrScale}>
          <Semi />
          <Needle
            className={styles.needle}
            style={{
              transform: `rotate(${degree}deg) translate(${translateX}px, ${translateY}px)`,
            }}
          />
          <h4>{ProductDashboardChartsViewProps.DQR_SCORE}</h4>
          <h2>{dqrData.totalScore}</h2>
        </div>
        <div>
          <table className={styles.dqrTable}>
            <tr>
              <th className={styles.dqrth}>
                {ProductDashboardChartsViewProps.Data_Quality_Indicators}
              </th>
              <th>{ProductDashboardChartsViewProps.Rating}</th>
            </tr>
            <tr>
              <td>{ProductDashboardChartsViewProps.Time}</td>
              <td>{dqrData.dqrMetrics?.time}</td>
            </tr>
            <tr>
              <td>{ProductDashboardChartsViewProps.Completeness}</td>
              <td>{dqrData.dqrMetrics?.completeness}</td>
            </tr>
            <tr>
              <td>{ProductDashboardChartsViewProps.Reliability}</td>
              <td>{dqrData.dqrMetrics?.reliability}</td>
            </tr>
            <tr>
              <td>{ProductDashboardChartsViewProps.Geography}</td>
              <td>{dqrData.dqrMetrics?.geography}</td>
            </tr>
            <tr>
              <td>{ProductDashboardChartsViewProps.Technology}</td>
              <td>{dqrData.dqrMetrics?.technology}</td>
            </tr>
          </table>
        </div>
      </Row>
    </div>
  );
};

export default DqrMetricComponent;
